'use strict';

export default typeof FormData !== 'undefined' ? FormData : null;



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/platform/browser/classes/FormData.js
// module id = 145
// module chunks = 1